/**
 * @file Album Purchased Custom Prints Details View.
 */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import AlbumPurchasedCustomPrintDetailsContainer from './AlbumPurchasedCustomPrintDetailsContainer';
import { getProductBasenames } from '../../../../../../util/role-definitions';
import ProLayout from '../../../../components/ProLayout';
import AlbumInnerPageHeader from '../../AlbumInnerPageHeader';

const propTypes = {
  basename: PropTypes.oneOf(getProductBasenames()).isRequired,
};

const AlbumPurchasedCustomPrintDetailsView = ({ basename }) => (
  <Fragment>
    <Helmet>
      <title>Album Custom Prints</title>
    </Helmet>

    <ProLayout.Main>
      <ProLayout.MainContent>
        <AlbumInnerPageHeader title="Print Order Details" />
        <AlbumPurchasedCustomPrintDetailsContainer basename={basename} />
      </ProLayout.MainContent>
    </ProLayout.Main>
  </Fragment>
);

AlbumPurchasedCustomPrintDetailsView.propTypes = propTypes;

export default AlbumPurchasedCustomPrintDetailsView;
